import React from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import TranslatableImage from '../../TranslatableImage'

export const Title = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '5px',
}))

export const Content = styled(Box)(() => ({
  paddingTop: '10px',
  paddingBottom: '10px',
}))

export function Preview({ src, alt, style, ...props }) {
  return <TranslatableImage {...props} src={src} alt={alt || 'Project preview'} style={{ width: '100%', marginBottom: 20, ...style }} />
}

Preview.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  style: PropTypes.object,
}
